export default {
  currentLayout: 'div',
  loadingCount: 0,
};
